import { render, staticRenderFns } from "./ClassModalButton.vue?vue&type=template&id=0606a3bc&scoped=true&"
import script from "./ClassModalButton.vue?vue&type=script&lang=ts&"
export * from "./ClassModalButton.vue?vue&type=script&lang=ts&"
import style0 from "./ClassModalButton.vue?vue&type=style&index=0&id=0606a3bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0606a3bc",
  null
  
)

export default component.exports